import { Box, SxProps, Theme, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';

interface FormFieldProps {
  label?: string;
  error?: boolean;
  helperText?: string;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
  required?: boolean;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  error = false,
  helperText,
  sx = {},
  children,
  required = false,
}) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mb: 2, ...sx }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '14px',
            color: theme.palette.formField.label,
            marginRight: '5px',
            minWidth: '130px',
            flexShrink: 0,
          }}
        >
          {label}
          {required && (
            <Box
              component="span"
              sx={{
                color: theme.palette.formField.helperError,
                marginLeft: '5px',
              }}
            >
              *
            </Box>
          )}
        </Typography>
        <Box sx={{ flex: 1 }}>{children}</Box>
      </Box>
      {helperText && (
        <Typography
          sx={{
            fontSize: '12px',
            color: error
              ? theme.palette.formField.helperError
              : theme.palette.formField.helperDefault,
            marginTop: '4px',
            marginLeft: '135px',
          }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default FormField;
